import { useHoneyGridApiFetch } from '@/queries/useHoneyGridApiFetch'
import { useQuery } from '@tanstack/react-query'

import type { Connection } from 'honeygrid-types/validators-and-types/ConnectionTypes'

export const connectionsQueryKey = (workspaceId: string) => ['connections', workspaceId] as const

/**
 * Hook to fetch all connections for a workspace
 */
export const useConnections = (workspaceId?: string) => {
	const authFetch = useHoneyGridApiFetch()

	return useQuery<Connection[]>({
		queryKey: connectionsQueryKey(workspaceId ?? ''),
		queryFn: async (): Promise<Connection[]> => {
			return await authFetch(`workspaces/${workspaceId}/connections`)
		},
		enabled: !!workspaceId,
	})
}
